import moment from "moment";
import { browserHistory } from "react-router";

/**
 * @name calculateBirthDateDiff
 * @description calculate users birth date diffs
 * @param {String} birthDate
 * @param {Boolean} onlyValidate
 * @returns {Boolean}
 * */
export const calculateBirthDateDiff = (birthDate, onlyValidate) => {
    let date = new Date(moment(birthDate, "YYYY-MM-DD")),
        diff = moment(birthDate.replace(date.getFullYear(), date.getFullYear() + 21), "YYYY-MM-DD");
    if (Date.now() < diff) {
        !onlyValidate && browserHistory.push("404");
        return false;
    }
    return true;
};